import { useState, useRef, useEffect } from 'react'

// A button that opens a checklist: what is checked is shown, what is not is
// hidden. `options` are { value, label, detail? } (detail: a small right-hand
// note, e.g. a count). `hidden` is the array of unchecked values, so an option
// that shows up later starts checked. Applies as you click.
export default function ChecklistDropdown({ label, options, hidden, onChange, allLabel = 'Todos', noneLabel = 'Ninguno', onlyLabel = 'solo' }) {
  const [open, setOpen] = useState(false)
  const ref = useRef(null)
  const total = options.length
  const shown = options.filter(o => !hidden.includes(o.value)).length
  const filtered = hidden.length > 0

  useEffect(() => {
    if (!open) return
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false) }
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false) }
    document.addEventListener('mousedown', onDoc)
    document.addEventListener('keydown', onKey)
    return () => { document.removeEventListener('mousedown', onDoc); document.removeEventListener('keydown', onKey) }
  }, [open])

  const toggle = (v) => onChange(hidden.includes(v) ? hidden.filter(x => x !== v) : [...hidden, v])
  const soloEste = (v) => onChange(options.map(o => o.value).filter(x => x !== v))

  return (
    <div ref={ref} className="relative inline-block">
      <button
        type="button" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-haspopup="true"
        className={`flex items-center gap-2 rounded-lg border px-3 py-2 text-sm ${filtered ? 'border-gray-800 bg-gray-800 text-white' : 'border-gray-300 bg-white text-gray-700 hover:bg-gray-50'}`}
      >
        <span>{label}</span>
        <span className={`text-xs ${filtered ? 'text-gray-300' : 'text-gray-400'}`}>{shown}/{total}</span>
        <span aria-hidden="true" className="text-[10px]">▾</span>
      </button>
      {open && (
        <div className="absolute z-30 mt-1 left-0 w-80 max-w-[90vw] bg-white border border-gray-200 rounded-lg shadow-lg">
          <div className="flex items-center justify-between px-3 py-2 border-b border-gray-100 text-xs">
            <button type="button" onClick={() => onChange([])} className="text-indigo-600 hover:underline">{allLabel}</button>
            <button type="button" onClick={() => onChange(options.map(o => o.value))} className="text-indigo-600 hover:underline">{noneLabel}</button>
          </div>
          <ul className="max-h-72 overflow-auto py-1">
            {options.map(o => {
              const on = !hidden.includes(o.value)
              return (
                <li key={o.value} className="group flex items-center gap-2 px-3 py-1.5 hover:bg-gray-50">
                  <label className="flex flex-1 items-center gap-2 min-w-0 cursor-pointer text-sm text-gray-800">
                    <input type="checkbox" className="accent-gray-900" checked={on} onChange={() => toggle(o.value)} />
                    <span className={`truncate ${on ? '' : 'text-gray-400 line-through'}`} title={o.label}>{o.label}</span>
                  </label>
                  {o.detail && <span className="text-xs text-gray-400 whitespace-nowrap">{o.detail}</span>}
                  <button type="button" onClick={() => soloEste(o.value)}
                    className="text-[11px] text-indigo-600 hover:underline opacity-0 group-hover:opacity-100 focus:opacity-100">{onlyLabel}</button>
                </li>
              )
            })}
          </ul>
        </div>
      )}
    </div>
  )
}
